/**
 * Pure mappings from game values to synth parameters. No Web Audio here — this
 * is the testable layer; the engine in sound.ts consumes these.
 */
const clamp = (v: number, lo: number, hi: number) => Math.max(lo, Math.min(hi, v));

export interface ToneSpec {
  startFreq: number;
  endFreq: number;
  gain: number;
  dur: number;
}

export interface ClashSpec {
  gain: number;
  /** Band-pass centre for the noise burst — lower for heavier hits. */
  noiseFreq: number;
  /** Add a low sine "boom" for big hits. */
  thud: boolean;
  dur: number;
}

/** Launch whoosh: brighter and louder with more launch power (0..1). */
export function launchTone(power: number): ToneSpec {
  const p = clamp(power, 0, 1);
  return { startFreq: 180, endFreq: 480 + p * 760, gain: 0.1 + p * 0.12, dur: 0.32 };
}

/** Clash impact: louder + lower (heavier) with bigger impact speed. */
export function clashSpec(impact: number, bigHit: boolean): ClashSpec {
  const i = Math.max(0, impact);
  return {
    gain: clamp(0.05 + i * 0.018, 0.05, 0.32),
    noiseFreq: clamp(1100 - i * 42, 220, 1100),
    thud: bigHit,
    dur: bigHit ? 0.24 : 0.09,
  };
}
